import script from "./CurrentUserMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentUserMenu.vue?vue&type=script&setup=true&lang=ts"

export default script